import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/i18n";

export const PageHero = ({ image, eyebrow, title, testid }) => {
  const { t } = useLang();
  return (
    <section data-testid={testid} className="relative flex min-h-[52vh] items-end overflow-hidden bg-mare">
      <motion.img
        src={image}
        alt=""
        initial={{ scale: 1.12 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/30 to-ink/20" />
      <div className="relative mx-auto w-full max-w-7xl px-4 pb-12 pt-36 sm:px-6 lg:px-8">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.25, duration: 0.6 }}
          className="mb-3 text-xs font-bold uppercase tracking-[0.28em] text-ochre"
        >
          {eyebrow}
        </motion.p>
        <h1 className="max-w-3xl font-serif text-4xl font-semibold leading-tight text-sand text-balance sm:text-5xl">
          {title}
        </h1>
      </div>
    </section>
  );
};

export const PageHeroCta = () => {
  const { t } = useLang();
  return (
    <Link
      to="/prenota"
      data-testid="pagehero-cta"
      className="mt-6 inline-flex items-center gap-2 rounded-full bg-terracotta px-6 py-3 text-sm font-bold text-sand shadow-lg shadow-terracotta/30 transition-all duration-200 hover:bg-terracotta-dark hover:-translate-y-0.5"
    >
      {t.hero.cta2} <ArrowRight size={16} />
    </Link>
  );
};
